import Route from 'cio/routes/base';
import { inject as service } from '@ember/service';
import AccountService from 'cio/services/account';

export default class IndexRoute extends Route {
  @service account!: AccountService;

  model() {
    return this.account.current;
  }
}
